import Component from 'inferno-component';
import { Grid, Divider, Header, Container } from 'semantic-ui-react';
import GridItem from '../item/GridItem';
import './Pros.css';

export default class Pros extends Component {

  render() {
    return (
      <Container id="pros" className="smt">
        <Grid.Row centered className="m-0">
          <Grid.Column>
              <Divider horizontal><Header as='h3'>Szolgáltatásunk előnyei</Header></Divider>
          </Grid.Column>
        </Grid.Row>

        <Grid columns={3} centered>
          <Grid.Row>
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={5}>
              <GridItem
                name='unhide'
                color='blue'
                description='Eszközeink nagy méretükkel és impozáns, üveg-felületű modern megjelenésükkel bármilyen környezetben magukra vonzzák a tekintetet.'
              />
            </Grid.Column>
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={5}>
              <GridItem
                name='marker'
                color='grey'
                description='Eszközeinket az egyetemi központok legfrekventáltabb helyeire kihelyezve azt az időszakot használjuk ki, mikor a hallgatók a legfogékonyabbak üzenete befogadására.'
              />
            </Grid.Column>
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={5}>
              <GridItem
                name='film'
                color='black'
                description='A digitális kijelzőn szöveges és dinamikus (pl. képek, videók) tartalmak megjelenítésére nyílik lehetőség.'
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={5} >
              <GridItem
                name='leaf'
                color='green'
                description='Környezetbarát, nincs szükség a marketinganyagok, tájékoztatók nyomtatására.'
              />
            </Grid.Column>
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={5} >
              <GridItem
                name='line chart'
                color='orange'
                description='A folyamatosan váltakozó képek, videók, információk marketing szempontból eredményesebbek, mivel figyelemfelkeltő hatásuk jelentősen meghaladja a hagyományos állóképekét, vagy az egyszerű nyomtatott szövegét.'
               />
            </Grid.Column>
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={5} >
              <GridItem
                name='money'
                color='green'
                description='Költséghatékony hirdetési lehetőséget kínálunk ügyfeleink számára.'
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pros/Pros.js